import { render, staticRenderFns } from "./ContactDpiEdit.vue?vue&type=template&id=65a194a7&"
import script from "./ContactDpiEdit.vue?vue&type=script&lang=js&"
export * from "./ContactDpiEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports